import React from "react";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import style from "../../assets/css/components/Form/Form.module.css";

import { Formik, Form } from "formik";
import Button from "../Button/Button";

import Input from "../Input/Input";
import { AddTeamInitialState, AddTeamValidationSchema } from "../../utils/team";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";

import { socket } from "../../config/socket";
const MySwal = withReactContent(Swal);

function FormAddTeam({ btnDelete }) {
  const handleSubmit = async (values) => {
    const { name, shortName, colorShirt } = values;

    socket.emit("addTeam", { name, shortName, colorShirt }, (team) => {
      MySwal.fire("Equipo agregado correctamente");
      console.log(team.name);
    });
  };

  // const formUpdateSubmit = async (values) => {
  //   const { shortName } = values;

  //   socket.emit("updateTeam", { shortName }, (team) => {
  //     MySwal.fire("Equipo actualizado");
  //   });
  // };

  return (
    <Formik
      initialValues={AddTeamInitialState}
      validationSchema={AddTeamValidationSchema}
      onSubmit={handleSubmit}
    >
      <Form className={style.form}>
        <Input name="name" title="Nombre de equipo" type="text" />
        <Input
          maxLength={8}
          name="shortName"
          title="Nombre corto"
          type="text"
        />
        <Input name="colorShirt" title="Color de camiseta" type="color" />
        <div
          className={
            btnDelete
              ? style.contButton
              : classNames(style.contButton, style.alignCenter)
          }
        >
          <Button text="Guardar" />
          {btnDelete ? (
            <button type="button" className={style.btnDelete}>
              <FontAwesomeIcon icon={faTrashAlt} />
            </button>
          ) : null}
        </div>
      </Form>
    </Formik>
  );
}

export default FormAddTeam;
